var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',_vm._g(_vm._b({},'IconBase',_vm.$props,false),_vm.$listeners),[_c('path',{attrs:{"d":"M15 1L8 7L1 1","stroke":"#6466ED","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }